import React from 'react';
import './Features.css';
import { FaLaptopCode, FaRobot, FaBrain, FaGraduationCap, FaLayerGroup, FaTools } from 'react-icons/fa';
import useClickSound from '../../hooks/useClickSound';

const Features = () => {
  const playClickSound = useClickSound();

  const handleCardClick = (e) => {
    playClickSound();
  };

  return (
    <section id="features" className="features-section">
      <div className="container container-narrow">
        <h2 className="section-header">What I Do</h2>
        <div className="row">
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaLaptopCode className="feature-icon" />
                <h5>BeSpoke SaaS Developer</h5>
                <p>Specialized in developing custom SaaS solutions across Mobile, Desktop & Web platforms with modern tech stack.</p>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaRobot className="feature-icon" />
                <h5>Business Automation & AI</h5>
                <p>Solutions Architect specializing in AI-driven business automation to streamline operations and boost efficiency.</p>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaBrain className="feature-icon" />
                <h5>AI Integration Expert</h5>
                <p>Implementing cutting-edge AI solutions to transform business processes and enhance decision-making capabilities.</p>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaGraduationCap className="feature-icon" />
                <h5>Enterprise IT Training</h5>
                <p>Comprehensive training programs for teams and organizations on modern tech stack and best practices.</p>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaLayerGroup className="feature-icon" />
                <h5>System Architecture</h5>
                <p>Designing scalable and efficient system architectures for complex enterprise applications.</p>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="#home" className="feature-card-link" onClick={handleCardClick}>
              <div className="feature-card">
                <FaTools className="feature-icon" />
                <h5>Tech Consultancy</h5>
                <p>Strategic technology consulting to help businesses navigate digital transformation and innovation.</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
